import React from "react"
import { Box, Text } from "@chakra-ui/react"

const ServiceText = ({ data }) => {
  return (
    <Box borderTop="1px" borderColor="dark_blue" mr={{ base: 0, lg: 8 }} mt={8}>
      <Text
        fontFamily="kepler-std-subhead"
        fontWeight="bold"
        fontSize="2xl"
        pt={4}
        pb={3}
      >
        Service
      </Text>
      <Text>{data}</Text>
    </Box>
  )
}

export default ServiceText
